import { Preferences } from "@capacitor/preferences";
import { isNative } from "@/lib/capacitor";

export const capacitorStorage = {
  async getItem(key: string): Promise<string | null> {
    if (!isNative) return localStorage.getItem(key);
    const { value } = await Preferences.get({ key });
    return value ?? null;
  },
  async setItem(key: string, value: string): Promise<void> {
    if (!isNative) { localStorage.setItem(key, value); return; }
    await Preferences.set({ key, value });
  },
  async removeItem(key: string): Promise<void> {
    if (!isNative) { localStorage.removeItem(key); return; }
    await Preferences.remove({ key });
  },
};
